if (__IS_LEGACY__) {
  require('core-js/stable')
}
async function init() {
  if (!('IntersectionObserver' in window)) {
    try {
      await import('intersection-observer' /* webpackChunkName: "intersection-observer" */)
    } catch (e) {
      console.error(e)
    }
  }

  // Loads the polyfill for custom elements for non-legacy browsers that need it (Edge)
  if ('customElements' in window === false) {
    import('@webcomponents/custom-elements').then(() => require('./client'))
  } else if (window.sanityPreview) {
    import('./sanity-preview.js' /* webpackChunkName: "dh-sg-sanity-preview" */).then(() =>
      require('./client')
    )
  } else {
    require('./client')
  }
}
init()
